import React from 'react';
import { BookMarked } from 'lucide-react';
import { SizeSpacingPanel, ColorsFontsPanel } from '../common/BlockStyleSettings';
import { BLOCK_FEATURES } from '../common/commonDefaults';

const ContentLibraryEditor = ({ block, onChange, profileId, theme, hideStylePanels }) => {
  const { content } = block;

  const updateContent = (field, value) => {
    onChange({
      ...block,
      content: { ...content, [field]: value },
    });
  };

  return (
    <div className="content-library-editor">
      <div className="editor-section">
        <div className="editor-header">
          <BookMarked size={20} />
          <h3>Content Library</h3>
        </div>
        <p className="editor-desc">
          Displays pinned items from your coaching library. Manage content from the Admin &rarr; Library tab.
        </p>
      </div>

      <div className="editor-section">
        <label className="editor-label">Section Title</label>
        <input
          type="text"
          value={content.title || ''}
          onChange={(e) => updateContent('title', e.target.value)}
          placeholder="Content Library"
          className="editor-input"
        />
      </div>

      <div className="editor-section">
        <label className="editor-label">Description</label>
        <textarea
          value={content.description || ''}
          onChange={(e) => updateContent('description', e.target.value)}
          placeholder="Study materials and puzzles"
          rows={2}
          className="editor-textarea"
        />
      </div>

      <div className="editor-row">
        <div className="editor-section">
          <label className="editor-label">Max Items</label>
          <input
            type="number"
            min={1}
            max={20}
            value={content.maxItems || 6}
            onChange={(e) => updateContent('maxItems', parseInt(e.target.value) || 6)}
            className="editor-input"
          />
        </div>

        <div className="editor-section">
          <label className="editor-label">Button Text</label>
          <input
            type="text"
            value={content.buttonText || ''}
            onChange={(e) => updateContent('buttonText', e.target.value)}
            placeholder="Browse Library"
            className="editor-input"
          />
        </div>
      </div>

      {!hideStylePanels && (<>
      <SizeSpacingPanel
        block={block}
        onChange={onChange}
        features={BLOCK_FEATURES['content-library']}
      />
      <ColorsFontsPanel
        block={block}
        onChange={onChange}
        theme={theme}
        features={BLOCK_FEATURES['content-library']}
      />
      </>)}

      <style>{`
        .content-library-editor {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .editor-header {
          display: flex;
          align-items: center;
          gap: 8px;
          color: var(--editor-text, #e2e8f0);
        }

        .editor-header h3 {
          margin: 0;
          font-size: 1rem;
          font-weight: 600;
        }

        .editor-desc {
          margin: 8px 0 0;
          font-size: 0.85rem;
          color: var(--editor-muted, #94a3b8);
          line-height: 1.4;
        }

        .editor-section {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .editor-row {
          display: flex;
          gap: 16px;
        }

        .editor-row .editor-section {
          flex: 1;
        }

        .editor-label {
          font-size: 0.8rem;
          font-weight: 600;
          color: var(--editor-text, #e2e8f0);
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .editor-input,
        .editor-textarea {
          padding: 8px 12px;
          background: var(--editor-input-bg, rgba(255, 255, 255, 0.05));
          border: 1px solid var(--editor-border, rgba(255, 255, 255, 0.1));
          border-radius: 6px;
          color: var(--editor-text, #e2e8f0);
          font-size: 0.9rem;
          font-family: inherit;
        }

        .editor-input:focus,
        .editor-textarea:focus {
          outline: none;
          border-color: #749555;
        }

        .editor-textarea {
          resize: vertical;
        }
      `}</style>
    </div>
  );
};

export default ContentLibraryEditor;
